import { genres } from '@/mocks/bookData';

const scoreBars = [
  { star: 5, percent: 62 },
  { star: 4, percent: 27 },
  { star: 3, percent: 8 },
  { star: 2, percent: 2 },
  { star: 1, percent: 1 },
];

export default function Reputation() {
  return (
    <section id="reputation" className="bg-primary-950 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs font-semibold text-background-100">
              <i className="ri-award-line"></i>
              读者口碑
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-background-50 md:text-4xl">
              每一份口碑，都来自真实的阅读
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              御宅书屋坚持用读者真实评分说话。严格的反刷分机制与人工审核，让每一条短评都值得信赖。
              你的每一次打分、每一条书评，都在帮助更多同好找到值得一读的作品。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {genres.map((g) => (
                <span
                  key={g}
                  className="rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-background-100"
                >
                  #{g}
                </span>
              ))}
            </div>
          </div>

          <div className="rounded-2xl bg-background-50 p-6 md:p-8">
            <div className="flex items-end justify-between">
              <div>
                <p className="text-xs text-foreground-600">综合读者评分</p>
                <p className="mt-1 flex items-baseline gap-1">
                  <span className="font-heading text-5xl font-black text-foreground-950">9.2</span>
                  <span className="text-sm text-foreground-500">/ 10</span>
                </p>
              </div>
              <div className="flex items-center gap-0.5 text-accent-600">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-lg"></i>
                ))}
              </div>
            </div>

            <div className="mt-6 space-y-2.5">
              {scoreBars.map((b) => (
                <div key={b.star} className="flex items-center gap-3">
                  <span className="flex w-10 shrink-0 items-center gap-1 text-xs font-medium text-foreground-600">
                    {b.star}星
                  </span>
                  <div className="h-2 flex-1 overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-accent-500"
                      style={{ width: `${b.percent}%` }}
                    ></div>
                  </div>
                  <span className="w-9 shrink-0 text-right text-xs text-foreground-600">{b.percent}%</span>
                </div>
              ))}
            </div>

            <div className="mt-6 flex items-center justify-between rounded-xl bg-secondary-100 px-4 py-3">
              <span className="flex items-center gap-2 text-sm text-secondary-900">
                <i className="ri-quill-pen-line"></i>
                本周新增书评
              </span>
              <span className="font-heading text-lg font-bold text-secondary-900">1,284 条</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}